
















import {Component, Mixins, Prop} from 'vue-property-decorator';
import { ITableColumn } from '@/interfaces/table-column';

@Component
export default class ColumnTitleContent extends Mixins() {
    @Prop({required: true}) readonly column!: ITableColumn;
    @Prop({required: false, default: 16}) readonly titlePadding!: number;
    @Prop({required: false, default: 18}) readonly sorterWidth!: number;
    @Prop({required: false, default: 12}) readonly filterDiff!: number;
    @Prop({required: false, default: 1.75}) readonly widthCoefficientCommon!: number;

    showTooltip: boolean = true;

    mounted() {
        this.showTooltip = this.checkTruncation();
    }

    get titleWidth() {
        let width = this.column.slotColumnTitleData.titleWidth || this.column.width;

        if (typeof width === 'string') {
            width = Number(width.replace('px', ''));
        }

        if (!this.column.slotColumnTitleData.titleWidth && this.column.width) {
            if (this.column.slotColumnTitleData.useWidthCoefficient && (this.column.slotColumnTitleData.widthCoefficient || this.widthCoefficientCommon)) {
                width = width * (this.column.slotColumnTitleData.widthCoefficient || this.widthCoefficientCommon);
            }
        }

        if (this.column.width) {
            width = width - this.titlePadding * 2;

            if (this.column.sorter) {
                width = width - this.sorterWidth;
            }

            if (this.column.scopedSlots && this.column.scopedSlots.filterDropdown) {
                width = width - this.filterDiff; // difference between filterIconWidth and titlePadding, because for filterIcon slot special logic
            }
        }

        return width ? width + 'px' : '100%';
    }

    checkTruncation(): boolean {
        const ellipsisElement = this.$refs.ellipsis as HTMLElement;

        return ellipsisElement && ellipsisElement.offsetWidth < ellipsisElement.scrollWidth;
    }
}
